import React from "react";
import { TripTypes } from "../../../../TripEventConsts";

function RegistrationPersonal(props) {
  const {
    registration: { travelApplication },
    tripLocation,
    tripType,
  } = props;

  const {
    additionalInfoNote,
    hasPriorTripExperience,
    jewishCampusInvolvementDescription,
    priorTripExperienceDescription,
    tripReason,
  } = travelApplication || {};

  const isConferenceTrip = tripType === TripTypes.Conference;
  const isLivingLinksTrip = tripType === TripTypes.LivingLinks;

  return (
    <div className="trip-student-detail-tab personal-tab">
      <div className="xl-text fw-700">Personal</div>
      {(isConferenceTrip || isLivingLinksTrip) && (
        <>
          <div className="student-detail-section">
            <div className="medium-text fw-700 mb-8">
              In two paragraphs or more describe why you want to join this trip
              and what you hope to gain from it.
            </div>
            <div>{tripReason}</div>
          </div>
          {!isConferenceTrip && (
            <div className="student-detail-section">
              <div className="medium-text fw-700 mb-8">
                Have you previously participated in a trip to {tripLocation}?
              </div>
              <div>
                {hasPriorTripExperience ? "Yes" : "No"}
                {priorTripExperienceDescription && (
                  <div className="mt-8">{priorTripExperienceDescription}</div>
                )}
              </div>
            </div>
          )}
          <div className="student-detail-section">
            <div className="medium-text fw-700 mb-8">
              Please tell us about your current Jewish campus involvement.
            </div>
            <div>{jewishCampusInvolvementDescription}</div>
          </div>
        </>
      )}
      <div className="student-detail-section">
        <div className="medium-text fw-700 mb-8">
          Is there anything else we should know about you or your application?
        </div>
        <div>{additionalInfoNote || "–"}</div>
      </div>
    </div>
  );
}

export default React.memo(RegistrationPersonal);
